import { Injectable, inject } from '@angular/core';
import { LernformKey } from '../../../../model/aggregations';
import { orderedFernLernformen } from '../../../../model/lernformen';
import { LernformFacettenService } from './lernformfacetten.service';
import { LernformUrlService } from './lernformurl.service';

@Injectable({ providedIn: 'root' })
export class FernLernformService extends LernformFacettenService {
  static identifier: LernformKey = LernformKey.Fern;

  constructor() {
    const lernformUrlService = inject(LernformUrlService);

    super(lernformUrlService, FernLernformService.identifier, orderedFernLernformen);
  }
}
